<div class="header">
  <span>
      <a href="#"><img src="/assets/images/generico/logo.png" class="logo"></a>
  </span>
  <div class="logout-container" *ngIf="identity || token">
      <span style="margin-right: 10px;"> <b>{{identity?.nombres + ' '+ identity?.apellidoP + ' ' + identity?.apellidoM}}</b> </span>
      <button class="logout-btn" (click)="logout()">Cerrar Sesión</button>
  </div>
</div>

<div class="container" *ngIf="!buscando">

  <mat-card class="example-card">
    <mat-card-header>
      <div class="row" style="width: 100%;">
        <div mat-card-avatar class="example-header-image"></div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="title1b">Seguimiento de Expediente</div>
        </div>
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 subTitle">
          <p>Dirección de Obras Municipales</p>
        </div>
      </div>
    </mat-card-header>
    <mat-card-content>

      <div class="row">
        <form [formGroup]="exp_form">
          <div class="rol-div">
            <h4 class="card-title">Ingrese el RUT de la Persona o Empresa</h4>
            <mat-form-field class="mat-field-rol">
              <input matInput type="text" placeholder="Ingrese el RUT" formControlName="rut" formatRut>
              <button mat-button *ngIf="rut.value" matSuffix mat-icon-button aria-label="Clear"
                (click)="rut.setValue('')">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>

          <div class="rol-div">
            <h4 class="card-title">Ingrese Número de Solicitud</h4>
            <mat-form-field class="mat-field-rol">
              <input matInput type="text" placeholder="Nº Solicitud" formControlName="numSol">
              <button mat-button *ngIf="numSol.value" matSuffix mat-icon-button aria-label="Clear"
                (click)="numSol.setValue('')">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </div>
        </form>

        <div class="btn-cont">
          <button color="primary" mat-raised-button (click)="get_expediente()"
            [disabled]="!exp_form.valid">Búsqueda</button>
        </div>

      </div>

    </mat-card-content>
    <mat-card-actions>

    </mat-card-actions>
  </mat-card>
</div>

<div class="container" *ngIf="buscando">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12" align="right">
      <p>
        <button color="primary" mat-raised-button (click)="volver()">Volver a buscar</button>
      </p>
    </div>

  </div>
  <mat-card class="example-card">
    <mat-card-header>
      <div class="row" style="width: 100%;">
        <div class="get-data-cont">

          <div class="title1b" align="center">DOM - Expedientes
          </div>
        </div>
      </div>

    </mat-card-header>
    <mat-card-content>

      <mat-accordion>
        <mat-expansion-panel [expanded]="true">
          <mat-expansion-panel-header>
            <mat-panel-title class="{{colorExpa1}}">
              Datos del Expediente
            </mat-panel-title>
          </mat-expansion-panel-header>
          <br>
          <div class="row">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2">
              <label class="parag">Dirección:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['TEd_Direc_Completa'] ?
                expediente_info[0].fieldData['TEd_Direc_Completa'] : 'No hay información ingresada' }}</label>
            </div>
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
          </div>

          <div class="row">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2">
              <label class="parag">N Solicitud:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{expediente_info[0].fieldData['_TEd_NumeroX'] ?
                expediente_info[0].fieldData['_TEd_NumeroX'] : 'No hay información ingresada' }}</label>
            </div>
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
          </div>

          <div class="row">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2">
              <label class="parag">Tipo:</label>
            </div>
            <div class="name_info col-lg-8 col-md-8 col-sm-8 col-xs-8">
              <label class="parag">{{ expediente_info[0].fieldData['Tramites::TRA_Tipo'] ?
                expediente_info[0].fieldData['Tramites::TRA_Tipo'] : 'No hay información ingresada' }} </label>
            </div>
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
          </div>

          <div class="row">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2">
              <label class="parag">Proyecto:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag"> {{ expediente_info[0].fieldData['TEd_Tema_Proyecto'] ?
                expediente_info[0].fieldData['TEd_Tema_Proyecto'] : 'No hay información ingresada' }} </label>
            </div>
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
          </div>


          <div class="row">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2">
              <label class="parag">ROL Propiedad:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['TEd_Rol_Calculo'] ?
                expediente_info[0].fieldData['TEd_Rol_Calculo'] : 'No hay información ingresada' }}
              </label>
            </div>
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
          </div>

          <div class="row">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2">
              <label class="parag">Fecha Ingreso:</label>
            </div>
            <div class="name_info col-lg-6 col-md-8 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['TEd_FechaCreacion'] ?
                expediente_info[0].fieldData['TEd_FechaCreacion'] : 'No hay información ingresada' }} </label>
            </div>
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
          </div>

          <div class="row">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2">
              <label class="parag">Estado:</label>
            </div>
            <div class="name_info col-lg-8 col-md-8 col-sm-8 col-xs-8">
              <label class="parag">{{ expediente_info[0].fieldData['TEd_Estado_Descripcion_WEB'] ?
                expediente_info[0].fieldData['TEd_Estado_Descripcion_WEB'] : 'No hay información ingresada' }} </label>
            </div>
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
          </div>

        </mat-expansion-panel>
      </mat-accordion>


      <mat-accordion *ngIf="expa1==true">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="{{colorExpa1}}">
              Arquitecto Revisor
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row" *ngIf="expediente_info[0].fieldData['Administracion 2::Adm_Nom_Completo']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Nombre:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['Administracion 2::Adm_Nom_Completo'] ?
                expediente_info[0].fieldData['Administracion 2::Adm_Nom_Completo'] : 'No hay información ingresada' }}
              </label>
            </div>
          </div>

          <div class="row" *ngIf="expediente_info[0].fieldData['Administracion 2::Adm_Fono']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Fono:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['Administracion 2::Adm_Fono'] ?
                expediente_info[0].fieldData['Administracion 2::Adm_Fono'] : 'No hay información ingresada' }} </label>
            </div>
          </div>

          <div class="row" *ngIf="expediente_info[0].fieldData['Administracion 2::Adm_Mail']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Email:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['Administracion 2::Adm_Mail'] ?
                expediente_info[0].fieldData['Administracion 2::Adm_Mail'] : 'No hay información ingresada' }} </label>
            </div>
          </div>

        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion *ngIf="expa2==true">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="{{colorExpa2}}">
              Acta de Observaciones
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="row" *ngIf="expediente_info[0].fieldData['TEd_Acta_Fecha_4_VB_Jefe']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Fecha Emisión Acta:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['TEd_Acta_Fecha_4_VB_Jefe'] ?
                expediente_info[0].fieldData['TEd_Acta_Fecha_4_VB_Jefe'] : 'No hay información ingresada' }} </label>
            </div>
          </div>

          <div class="row" *ngIf="expediente_info[0].fieldData['TEd_Acta_Fecha_Notificacion']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Fecha de Notificación Acta:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['TEd_Acta_Fecha_Notificacion'] ?
                expediente_info[0].fieldData['TEd_Acta_Fecha_Notificacion'] : 'No hay información ingresada' }} </label>
            </div>
          </div>


          <div class="row" *ngIf="expediente_info[0].fieldData['TEd_Acta_Fecha_9_Reingreso_Acta']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Fecha de Reingreso:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['TEd_Acta_Fecha_9_Reingreso_Acta'] ?
                expediente_info[0].fieldData['TEd_Acta_Fecha_9_Reingreso_Acta'] : 'No hay información ingresada' }}
              </label>
            </div>
          </div>

          <div class="row"
            *ngIf="expediente_info[0].fieldData['TEd_Acta_Fecha_Notificacion']!='' &&  expediente_info[0].fieldData['random_acta']!='' ">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Descarga del documento:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">

              <a href="https://bucket-dom-mpa.s3.amazonaws.com/{{expediente_info[0].fieldData['random_acta']}}.pdf"
                target="_blank" style="font-weight: 800;display: flex;
                height: 1.5vh;">Descarga</a>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>

      <mat-accordion *ngIf="expa3==true">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="{{colorExpa3}}">
              Cálculo de Derecho
            </mat-panel-title>
          </mat-expansion-panel-header>

          <div class="row" *ngIf="expediente_info[0].fieldData['TUr_Acta_5_Cal_Autoriza_Pago']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Fecha de Cálculo:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['TUr_Acta_5_Cal_Autoriza_Pago'] ?
                expediente_info[0].fieldData['TUr_Acta_5_Cal_Autoriza_Pago'] : 'No hay información ingresada' }}
              </label>
            </div>
          </div>

          <div class="row" *ngIf="expediente_info[0].fieldData['TUr_Acta_6_Cal_Notifica_Pago']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Fecha de Notificación:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['TUr_Acta_6_Cal_Notifica_Pago'] ?
                expediente_info[0].fieldData['TUr_Acta_6_Cal_Notifica_Pago'] : 'No hay información ingresada' }}
              </label>
            </div>
          </div>

          <div class="row"
            *ngIf="expediente_info[0].fieldData['TUr_Acta_6_Cal_Notifica_Pago']!='' && expediente_info[0].fieldData['random_calculo']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Descarga del documento cálculo de derecho:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">

              <a href="https://bucket-dom-mpa.s3.amazonaws.com/{{expediente_info[0].fieldData['random_calculo']}}.pdf"
                target="_blank" style="font-weight: 800;display: flex;
              height: 1.5vh;">Descarga</a>
            </div>
          </div>

          <div class="row"
            *ngIf="expediente_info[0].fieldData['TUr_Acta_6_Cal_Notifica_Pago']!='' && expediente_info[0].fieldData['random_aporte']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Descarga del documento cálculo de aporte:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">

              <a href="https://bucket-dom-mpa.s3.amazonaws.com/{{expediente_info[0].fieldData['random_aporte']}}.pdf"
                target="_blank" style="font-weight: 800;display: flex;
              height: 1.5vh;">Descarga</a>
            </div>
          </div>

        </mat-expansion-panel>
      </mat-accordion>


      <mat-accordion *ngIf="expa4==true && expediente_info[0].fieldData['TEd_Rechazo_Fecha']==''">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="{{colorExpa4}}">
              Resultado de Expediente: {{ expediente_info[0].fieldData['TEd_Estado_Descripcion_WEB'] ?
              expediente_info[0].fieldData['TEd_Estado_Descripcion_WEB'] : '-' }}
            </mat-panel-title>
          </mat-expansion-panel-header>


          <div class="row" *ngIf="expediente_info[0].fieldData['TEd_Exp_Numero']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Número:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['TEd_Exp_Numero'] ?
                expediente_info[0].fieldData['TEd_Exp_Numero'] : 'No hay información ingresada' }} </label>
            </div>
          </div>

          <div class="row" *ngIf="expediente_info[0].fieldData['TEd_Exp_Fecha']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Fecha:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['TEd_Exp_Fecha'] ?
                expediente_info[0].fieldData['TEd_Exp_Fecha'] : 'No hay información ingresada' }} </label>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>


      <!--    <mat-accordion *ngIf="expa5==true && expediente_info[0].fieldData['TEd_Rechazo_Fecha']!=''">
        <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
          <mat-expansion-panel-header>
            <mat-panel-title class="{{colorExpa5}}">
              Rechazo
            </mat-panel-title>
          </mat-expansion-panel-header>


          <div class="row" *ngIf="expediente_info[0].fieldData['TEd_Rechazo_Numero']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Numero de Rechazo:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['TEd_Rechazo_Numero'] ?
                expediente_info[0].fieldData['TEd_Rechazo_Numero'] : 'No hay información ingresada' }} </label>
            </div>
          </div>

          <div class="row" *ngIf="expediente_info[0].fieldData['TEd_Rechazo_Fecha']!=''">
            <div class="name_info col-lg-2 col-md-2 col-sm-2 col-xs-2"></div>
            <div class="name_info col-lg-4 col-md-4 col-sm-4 col-xs-4">
              <label class="parag">Fecha de rechazo:</label>
            </div>
            <div class="name_info col-lg-6 col-md-6 col-sm-6 col-xs-6">
              <label class="parag">{{ expediente_info[0].fieldData['TEd_Rechazo_Fecha'] ?
                expediente_info[0].fieldData['TEd_Rechazo_Fecha'] : 'No hay información ingresada' }} </label>
            </div>
          </div>
        </mat-expansion-panel>
      </mat-accordion>
 -->

    </mat-card-content>
    <mat-card-actions>

    </mat-card-actions>
  </mat-card>

</div>